var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { avatarHtml, formatDate } from '@/support/String';
import DataTable from '@/components/data-table/DataTable';
import ImageInput from '@/components/dialog/image-input/ImageInput';
import ErrorHandler from '@/support/ErrorHandler';
import { cloneDeep } from 'lodash';
import { Project } from '@/models/Project';
let Organization = class Organization extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Organization';
        this.project = null;
        this.projectClone = new Project();
        //
        this.isEditing = false;
        this.isEditingDob = false;
        this.formatDob = formatDate;
        this.file = null;
        this.baseImage = null;
        this.isChangingAvatar = false;
        this.passwordHidden = true;
        this.password = {
            old: '',
            new: '',
            confirmation: '',
        };
    }
    get breadcrumbs() {
        return [{ name: 'Admin' }, { name: 'Organizations', path: '/admin/organizations' }, { name: 'Test' }];
    }
    get tableOptions() {
        return {
            name: {
                singular: 'Guardian',
                plural: 'Guardians',
            },
            headers: [
                {
                    text: '',
                    value: 'avatar',
                    transform: avatarHtml,
                },
                {
                    text: this.$tc('name.title'),
                    value: 'name',
                    action: '/students/{id}',
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/students/{id}',
                },
            ],
            filters: [],
            model: new Project(),
        };
    }
    get tableVisibility() {
        return {
            search: false,
            total: false,
            limit: false,
            pagination: false,
            checkboxes: false,
        };
    }
    async mounted() {
        this.project = await this.fetchProject();
    }
    cloneProject(project) {
        this.projectClone = cloneDeep(project);
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    async fetchProject() {
        const project = await new Project()
            .find(this.$route.params.id)
            .catch((error) => {
            ErrorHandler.network(error);
            return null;
        });
        if (project) {
            this.cloneProject(project);
        }
        return project;
    }
    async updateProject() {
        // Generate payload from somewhere.....
        const payload = {};
        new Project({ id: this.$route.params.id }).update(payload);
    }
};
Organization = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            ImageInput,
        },
    })
], Organization);
export default Organization;
